module.exports = __webpack_public_path__ + "static/img/desktop_bkg.2fb9acfd.png";